import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";

import DialogTitle from "@mui/material/DialogTitle";
import CustomTextField from "../../Components/TextField";
import { FormHelperText, Chip } from "@mui/material";
import * as yup from "yup";
import { useFormik, Form } from "formik";
import ReactLoading from "react-loading";

import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/system";
import { sentInviteAction } from "../../Redux/Actions/userAction";
import { useErrorHandler } from "../../hooks";
import HelmetReact from "../../Components/Helmet";
import { getClientsEmailAction } from "../../Redux/Actions/userAction";
import Autocomplete from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";
const InvitePatientModal = ({ open, setOpen }) => {
  const dispatch = useDispatch();
  const { setMsgConfig } = useErrorHandler();
  const { emailsList } = useSelector((state) => state.User);
  //handle and validate form
  const formik = useFormik({
    initialValues: {
      email: [],
      message: "",
    },
    enableReinitialize: true,
    validationSchema: yup.object({
      email: yup
        .array()
        .of(
          yup
            .string()
            .email("Invalid email address")
            .required("Email is required")
        )
        .min(1, "At least one email address is required"),
      message: yup.string().required("Please Enter Message"),
    }),
    onSubmit: () => {
      let payload = {
        email: JSON.stringify(formik.values.email),
        message: formik.values.message,
      };
      dispatch(sentInviteAction(payload));
      setMsgConfig({
        alertOpen: true,
        message: "Something went wrong!!",
        severity: "error",
        autoHideDuration: 2000,
      });
      setOpen(!open);
    },
  });

  //call for get clients email list
  useEffect(() => {
    dispatch(
      getClientsEmailAction({
        key: "",
      })
    );
  }, [dispatch]);

  const handleClose = () => {
    setOpen(!open);
  };

  //set selected emails
  const handleOnChange = (event, option) => {
    formik.setFieldValue("email", option);
  };
  const ITEM_HEIGHT = 48;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5,
      },
    },
  };

  return (
    <div>
      <HelmetReact name="User" />
      <Dialog open={open} onClose={handleClose} className="invite-modal">
        <DialogTitle>INVITE NEW CLIENT</DialogTitle>
        <DialogContent>
          <Box className="form-control-cc">
            <Autocomplete
              multiple
              id="tags-outlined"
              options={emailsList ? emailsList?.map((option) => option?.email):[]}
              freeSolo
              fullWidth
              onChange={handleOnChange}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Client Email"
                  placeholder="Client Email"
                  error={formik.touched.email && Boolean(formik.errors.email)}
                />
              )}
            />
            {formik.touched.email && formik.errors.email && (
              <FormHelperText className="error_message">
                {formik?.errors?.email?.includes("Invalid email address")
                  ? "Invalid email address"
                  : formik?.errors?.email}
              </FormHelperText>
            )}
          </Box>
          <Box className="form-control-cc">
            <CustomTextField
              rows={6}
              fieldType="textInput"
              multiline
              label="Message"
              name="message"
              required
              fullWidth
              className="form-control"
              value={formik.values.message}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.message && Boolean(formik.errors.message)}
            />
            {formik.touched.message && formik.errors.message && (
              <FormHelperText className="error_message">
                {formik.errors.message}
              </FormHelperText>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button className="btn-dark" variant="outlined" onClick={handleClose}>
            Cancel
          </Button>

          <Button
            className="btn-dark"
            variant="contained"
            onClick={formik.handleSubmit}
          >
            SEND INVITE
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default InvitePatientModal;
